import React, { useEffect,useState } from "react";
import './NavBar.css';
import { Link } from "react-router-dom";
import { CheckProductDetail, ValidateUserType,decruptCipher } from "../Services/CommonLibrary"
import $ from 'jquery'


function NavBar() {
    
    CheckProductDetail();
    const [pathname, setPathname] = useState('');
    const [tabMenu, setTabMenu] = useState('');
    let storage= JSON.parse(localStorage.getItem('programDetail')) ? JSON.parse(localStorage.getItem('programDetail')) : 0;
    let accessType= localStorage.getItem('access');
    
    let showProgramChange = true;
    const locationSplit = window.location.href.split('/');
    if(locationSplit[locationSplit.length-1]=='super-overview'){
        showProgramChange = false;
    }
   if(window.location.pathname!=pathname){
    setPathname(window.location.pathname);
   }
   
    useEffect(() => {

        // var menuData= localStorage.getItem('accessTab');
        // const menuArrData = JSON.parse(menuData);
        // // console.log('menuArrData',menuArrData)
        // setTabMenu(menuArrData);

        var menuData= localStorage.getItem('accessTab');
        // console.log('menuArrData',menuData)
        const menuArrData = decruptCipher(menuData);
        console.log('menuArrData',menuArrData)
        setTabMenu(menuArrData);

        $('#sidebarCollapse ul li').click(function(){
            $('.navbar-toggler').click();
        });   
        $('.nav-item a').click(function(){
            $('.nav-item .nav-link').removeClass('active');
            $(this).addClass('active');
        }) 
        
             
        const highlightedItems = document.querySelectorAll(".nav-item a");
        // const pathname = window.location.pathname; 
        
        highlightedItems.forEach((userItem) => {
            
            if(userItem.getAttribute("href")==pathname){
                userItem.classList.add("active");
            }else{
                userItem.classList.remove("active");
            }
        });  
    }, [pathname]);

    console.log('tabMenu',tabMenu)

   

    return (
       
        
        <nav className="navbar show navbar-vertical h-lg-screen navbar-expand-lg px-0 py-3 navbar-light bg-white border-bottom border-bottom-lg-0 border-end-lg" id="navbarVertical">
            <div className="container-fluid">

                <button className="navbar-toggler ms-n2" type="button" data-bs-toggle="collapse" data-bs-target="#sidebarCollapse" aria-controls="sidebarCollapse" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                {/* {/* <!-- Brand --> */}
                <a className="navbar-brand py-lg-0 mb-lg-3 px-lg-3 me-0" href="#">
                    <img src="https://appcdn.goqii.com/storeimg/36561_1672304537.png" className="goqii-logo" alt="..." />
                </a>
                {storage.programId>0 && showProgramChange ?
                <div className="change-program-box">
                        <h5 style={{background: "rgb(198 217 250)",textalign: "center",borderRadius: "10px",padding: "10px", color: "#333"}}>{storage.programName}<Link to="/program-list"><span className="change-program-btn"><i className="bi bi-arrow-left-right" style={{color:"#6b7b93", paddingRight:"7px"}}></i> Change Program</span></Link></h5>
                </div>
                 : null}
                
                <div className="collapse navbar-collapse" id="sidebarCollapse">
                {storage.programId>0 ? 
                    <ul className="navbar-nav">
                        {tabMenu ? tabMenu.map((data, i) => (
                            <li className="nav-item" key={`menu_${i}`}>
                                <Link className="nav-link" to={data.href}>
                                    <i className={`bi ${data.icon}`}></i><span className="nav-background">{data.title}</span>
                                </Link>
                            </li>
                        )) : ''}
                    </ul>
                : null}   
                    <hr className="navbar-divider my-1 opacity-20" />
                    
                    <div className="mt-auto"></div>
                    
                    <ul className="navbar-nav">
                        {/* <li className="nav-item">
                            <Link className="nav-link" to="/profile">
                                <i className="bi bi-person-square"></i> Account
                            </Link>
                        </li> */}
                        <li className="nav-ite">

                            <Link className="nav-link" to="/logout">
                                <i className="bi bi-box-arrow-left"></i> Logout
                            </Link>
                        </li>
                    </ul>
                </div>
                
            </div>
        </nav>
        
        


    );
}
export default NavBar;	